import './Header.less';
import React, {useState, useEffect, forwardRef } from 'react';
import __ from "../../../i18n";
import {Link} from "react-router-dom";
import routes from "../../../routing/routes";
import Icon from "../../../../bootstrap/components/icon/Icon";
import ShareButton from "../share-button/ShareButton";
import FavorButton from "../favor-button/FavorButton";


function Header({course, creator}, ref) {

    return <div className="header" ref={ref}>
        <div className="row">
            <div className="info-block">
                <h1 className="title">{course.name}</h1>
                <div className="description">{course.description}</div>
                <div className="bottom-bar">
                    <table>
                        <tbody>
                        <tr>
                            <td><Icon name="user"/></td>
                            <td>
                                <span className="label">{__('Created by')}</span>
                                {__(' ')}
                                <Link to={routes.user_profile.getUrl(creator.id)}>
                                    {creator.full_name}
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td><Icon name="calendar"/></td>
                            <td>{__('Last updated ::date(DATE)', {date: course.update_time})}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="actions">
                        <FavorButton course={course}/>
                        <ShareButton course={course}/>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}

export default forwardRef(Header);